import { useState } from 'react';
import {
	Flex,
	Box,
	FormControl,
	FormErrorMessage,
	FormLabel,
	Input,
	Stack,
	Button,
	Heading,
	useColorModeValue,
} from '@chakra-ui/react';

import { setPassword } from './App/auth';

export const Invite = ({ setUser, search }) => {
	const [login, setLogin] = useState({});
	const [invalid, setInvalid] = useState(false);
	const handleFieldChange = ({ target: { name, value } }) =>
		setLogin({ ...login, [name]: value });
	const handleSubmit = () => {
		const { password, confirm } = login;
		if (password !== confirm) return setInvalid(true);
		setPassword({ password, search }).then(response => {
			if (typeof response.data.error === 'string') return setInvalid(true);
			window.location.search = '';
		});
	};

	return (
		<Flex
			minH={'100vh'}
			align={'center'}
			justify={'center'}
			bg={useColorModeValue('gray.50', 'gray.800')}
		>
			<Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
				<Stack align={'center'}>
					<Heading fontSize={'4xl'}>Set password for your account</Heading>
				</Stack>
				<Box
					rounded={'lg'}
					bg={useColorModeValue('white', 'gray.700')}
					boxShadow={'lg'}
					p={8}
				>
					<Stack spacing={4}>
						<FormControl id="password" isInvalid={invalid}>
							<FormLabel>Password</FormLabel>
							<Input
								name="password"
								type="password"
								onChange={handleFieldChange}
							/>
							<FormErrorMessage>must match confirm</FormErrorMessage>
						</FormControl>
						<FormControl id="confirm" isInvalid={invalid}>
							<FormLabel>Confirm password</FormLabel>
							<Input
								name="confirm"
								type="password"
								onChange={handleFieldChange}
							/>
							<FormErrorMessage>must match password</FormErrorMessage>
						</FormControl>
						<Stack spacing={10}>
							<Button
								bg={useColorModeValue('blue.800', 'blue.300')}
								color={'white'}
								_hover={{
									bg: useColorModeValue('blue.300', 'blue.800'),
								}}
								onClick={handleSubmit}
							>
								Create account
							</Button>
						</Stack>
					</Stack>
				</Box>
			</Stack>
		</Flex>
	);
};
